import type { SxProps, Theme } from '@mui/material/styles';
import { neutral, primary, error } from '_lex/_foundations/phxColors';

export const workflowStepListRowSx: SxProps<Theme> = {
  display: 'flex',
  alignItems: 'center',
  gap: 1,
  width: '100%',
};

export const workflowStepListFixedEndSpacerSx: SxProps<Theme> = {
  flexShrink: 0,
  width: 34,
  minWidth: 34,
};

export const readOnlyDashedTextFieldSx: SxProps<Theme> = {
  '&.MuiFormControl-root': {
    paddingTop: 4,
  },
  '& .MuiOutlinedInput-root': {
    minHeight: 45,
    bgcolor: neutral[50],
    borderRadius: 2,
    '& fieldset': {
      borderStyle: 'dashed',
      borderColor: neutral[300],
    },
    '&:hover fieldset': {
      borderStyle: 'dashed',
      borderColor: neutral[300],
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1,
      borderStyle: 'dashed',
      borderColor: neutral[300],
    },
  },
  '& .MuiInputBase-input': {
    cursor: 'default',
    py: 2.25,
    px: 2.5,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: neutral[500],
    lineHeight: 1.5,
    boxSizing: 'border-box',
  },
};

export const editableStepTextFieldSx: SxProps<Theme> = {
  '&.MuiFormControl-root': {
    paddingTop: 4,
  },
  '& .MuiOutlinedInput-root': {
    minHeight: 45,
    bgcolor: neutral[25],
    borderRadius: 2,
    '& fieldset': {
      borderColor: neutral[200],
    },
    '&:hover fieldset': {
      borderColor: neutral[300],
    },
    '&.Mui-focused fieldset': {
      borderWidth: 1,
      borderColor: neutral[300],
    },
  },
  '& .MuiInputBase-input': {
    py: 2.25,
    px: 2.5,
    fontSize: '0.875rem',
    fontWeight: 500,
    color: neutral[800],
    lineHeight: 1.5,
    boxSizing: 'border-box',
  },
};

export const selectedMiddleStepRowSx: SxProps<Theme> = {
  borderRadius: 2,
  border: `1px solid ${primary[500]}`,
  bgcolor: primary[25],
};

export const middleStepRowSx: SxProps<Theme> = {
  borderRadius: 2,
  border: `1px solid ${neutral[200]}`,
  bgcolor: neutral[25],
  '&:hover': {
    borderColor: neutral[300],
  },
};

export const errorMiddleStepRowSx: SxProps<Theme> = {
  borderRadius: 2,
  border: `1px solid ${error[500]}`,
  bgcolor: neutral[25],
  '&:hover': {
    borderColor: error[600],
  },
};
